import { QuoteCompaisonColumnType } from '../../../types';

export const COLUMN_TYPE_LABELS: Record<QuoteCompaisonColumnType, string> = {
  text: 'Texte court',
  number: 'Montant',
  multiline: 'Texte long',
};

export const COLUMN_TYPES = ['text', 'number', 'multiline'] as const satisfies readonly QuoteCompaisonColumnType[];
